export const LANDING = {
  // Nav
  nav: "scrm-nav",
  navLogo: "scrm-nav-logo",
  navJoinBtn: "scrm-nav-join-btn",

  // Hero
  hero: "scrm-hero",
  heroWordmark: "scrm-hero-wordmark",
  heroHeadline: "scrm-hero-headline",
  heroSubheadline: "scrm-hero-subheadline",
  heroJoinBtn: "scrm-hero-join-btn",

  // Drop 001
  dropSection: "scrm-drop-section",
  dropTitle: "scrm-drop-title",
  dropFeatureList: "scrm-drop-features",
  dropMockup: (key) => `scrm-drop-mockup-${key}`,

  // How it works
  howSection: "scrm-how-section",
  howStep: (n) => `scrm-how-step-${n}`,

  // Members access form
  membersSection: "scrm-members-section",
  membersForm: "scrm-members-form",
  memberInputName: "scrm-member-input-name",
  memberInputEmail: "scrm-member-input-email",
  memberInputPhone: "scrm-member-input-phone",
  memberSubmitBtn: "scrm-member-submit-btn",
  memberSuccess: "scrm-member-success",
  memberError: "scrm-member-error",

  // Archive
  archiveSection: "scrm-archive-section",
  archiveCard: (slug) => `scrm-archive-card-${slug}`,

  // Footer
  footer: "scrm-footer",
  footerInstagram: "scrm-footer-instagram",
  footerTiktok: "scrm-footer-tiktok",
  footerContact: "scrm-footer-contact",
};
